import * as React from 'react';
import { connect } from 'react-redux';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import style from './Trees.style';
import GeofenceInfoPanel from '../geotree-info-panel/GeotreeInfoPanel';
import FMGeofenceActionsToolbar from '../../molecules/FMGeofenceActionsToolbar';
import {
    FMIconButton,
    FMToolbar,
    FMSearchInput as SearchInput,
    FMContainer,
    FMIconMenuButton,
} from 'atoms';
import {
    FMTreeGroupWithItemsNode as GroupNode,
    FMTreeGeofenceNode as ItemNode,
} from 'molecules';
import { FMTreeBase as Tree, FMImportDialog } from 'organisms';
import {
    TreeType,
    TreeDisplayStateType,
    TreeNodeType,
    GeofenceType,
} from '../../../store/FMTree/FMTreeReducer';
import SplitPane from 'react-split-pane';
import { Base64 } from 'js-base64';
import { getGroupIdNearestToSelectedNode, getIsEditModeEnabled } from '../../../store/FMTree/FMTReeSelectors';
import { RootState } from '../../../store/index';
import DisabledArea from '../../atoms/DisabledArea';
interface StateProps {
    idForImportDialog: string;
    editModeEnabled: boolean;
}

type Props = StateProps & WithStyles;

interface State {
    importDialogOpened: boolean;
    importDialogLoading: boolean;
}

class GeofencesTree extends React.Component<Props, State> {

    private treeRef: any;

    constructor(props: Props) {
        super(props);

        this.treeRef = React.createRef();

        this.state = {
            importDialogOpened: false,
            importDialogLoading: false,
        };
    }

    private expandAllGroups = () => {
        if (this.treeRef !== null) {
            this.treeRef.current.expandAllGroups();
        }
    }

    private collapseAllGroups = () => {
        if (this.treeRef !== null) {
            this.treeRef.current.collapseAllGroups();
        }
    }

    private checkAllNodes = () => {
        if (this.treeRef !== null) {
            this.treeRef.current.checkAllNodes();
        }
    }

    private uncheckAllNodes = () => {
        if (this.treeRef !== null) {
            this.treeRef.current.uncheckAllNodes();
        }
    }

    public enableEditMode = () => {
        if (this.treeRef !== null) {
            this.treeRef.current.enableEditMode();
        }
    }

    public disableEditMode = () => {
        if (this.treeRef !== null) {
            this.treeRef.current.disableEditMode();
        }
    }

    public searchNode = (textFromInput: string) => {
        if (this.treeRef !== null) {
            this.treeRef.current.searchNode(textFromInput);
        }
    }

    public showDataAsTree = () => {
        if (this.treeRef !== null) {
            this.treeRef.current.showAsTree();
        }
    }

    public showDataAsList = () => {
        if (this.treeRef !== null) {
            this.treeRef.current.showAsList();
        }
    }

    public deleteSelectedNode = () => {
        if (this.treeRef !== null) {
            this.treeRef.current.deleteSelectedNode();
        }
    }

    public deleteCheckedOrSelectedItems = () => {
        if (this.treeRef !== null) {
            this.treeRef.current.deleteCheckedOrSelectedItems();
        }
    }

    public exportCheckedOrSelectedItems = () => {
        if (this.treeRef !== null) {
            this.treeRef.current.exportCheckedOrSelectedItems('wialon');
        }
    }

    public exportCheckedOrSelectedItemsToExcel = () => {
        if (this.treeRef !== null) {
            this.treeRef.current.exportCheckedOrSelectedItems('excel');
        }
    }

    private openImportDialog = () => {
        this.setState({ importDialogOpened: true });
    }

    private closeImportDialog = () => {
        this.setState({ importDialogOpened: false });
    }

    private importGeofences = (data: string, parentId: string) => {
        let content = Base64.encode(data);

        if (content.length === 0) {
            return;
        }

        if (parentId.length === 0) {
            return;
        }

        if (this.treeRef !== null) {
            this.setState({ importDialogLoading: true });
            this.treeRef.current.importItems(content, parentId)
                .then(() => {
                    this.setState({ importDialogLoading: false });
                    this.closeImportDialog();
                });
            return;
        }

        this.closeImportDialog();
    }

    public editNode = () => {
        this.treeRef.current.fetchSelectedNodeEditData();
    }

    public createPoint = () => {
        this.treeRef.current.fetchGeotreeNewNodeData(TreeNodeType.item, GeofenceType.point);
    }

    public createLine = () => {
        this.treeRef.current.fetchGeotreeNewNodeData(TreeNodeType.item, GeofenceType.line);
    }

    public createPolygon = () => {
        this.treeRef.current.fetchGeotreeNewNodeData(TreeNodeType.item, GeofenceType.polygon);
    }

    public createGroup = () => {
        if (this.treeRef !== null) {
            this.treeRef.current.fetchGeotreeNewNodeData(TreeNodeType.group);
        }
    }

    public render() {
        return (
            <SplitPane
                split="horizontal"
                defaultSize="60%"
                minSize={250}
                maxSize={-200}
                className={this.props.classes.splitPane}
            >
                <FMContainer square={true} className={this.props.classes.treePanel}>
                    {
                        this.props.editModeEnabled && <DisabledArea />
                    }
                    <FMToolbar variant="dense">
                        <SearchInput
                            searchNode={this.searchNode}
                            placeholder={fmtools.translate('Search')}
                        />
                    </FMToolbar>
                    <FMToolbar variant="dense">
                        <FMIconButton
                            color="secondary"
                            type="expand"
                            onClick={this.expandAllGroups}
                            tooltip={fmtools.translate('expand_tree')}
                        />
                        <FMIconButton
                            color="secondary"
                            type="collapse"
                            onClick={this.collapseAllGroups}
                            tooltip={fmtools.translate('collapse_tree')}
                        />
                        <FMIconButton
                            color="secondary"
                            type="checked"
                            onClick={this.checkAllNodes}
                            tooltip={fmtools.translate('SelectAll')}
                        />
                        <FMIconButton
                            color="secondary"
                            type="unchecked"
                            onClick={this.uncheckAllNodes}
                            tooltip={fmtools.translate('UnselectAll')}
                        />
                        <FMIconButton
                            color="secondary"
                            type="treeview"
                            onClick={this.showDataAsTree}
                            tooltip={fmtools.translate('ShowGroups')}
                        />
                        <FMIconButton
                            color="secondary"
                            type="listview"
                            onClick={this.showDataAsList}
                            tooltip={fmtools.translate('HideGroups')}
                        />
                        <FMIconMenuButton
                            iconType="multiplegeos"
                            menuId="actionsWithMultipleGeofences"
                            menuData={[
                                { text: fmtools.translate('Export'), action: this.exportCheckedOrSelectedItems },
                                { text: fmtools.translate('ExportToExcel'), action: this.exportCheckedOrSelectedItemsToExcel },
                                { text: fmtools.translate('Import'), action: this.openImportDialog },
                                { text: fmtools.translate('Delete'), action: this.deleteCheckedOrSelectedItems },
                            ]}
                            tooltip={fmtools.translate('ActionsWithMultipleGeofences')}
                        />
                    </FMToolbar>
                    <FMContainer className={this.props.classes.treeBlock}>
                        <Tree
                            ref={this.treeRef}
                            treeType={TreeType.geofencesTree}
                            treeDisplayState={TreeDisplayStateType.mainGeofencesTree}
                            groupNode={GroupNode}
                            itemNode={ItemNode}
                        />
                    </FMContainer>
                </FMContainer>
                <FMContainer square={true} className={this.props.classes.infoPanel}>
                    <FMGeofenceActionsToolbar treeDisplayState={TreeDisplayStateType.mainGeofencesTree} />
                    <GeofenceInfoPanel />
                    {this.state.importDialogOpened &&
                        <FMImportDialog
                            title={fmtools.translate('import_zone')}
                            import={this.importGeofences}
                            cancel={this.closeImportDialog}
                            filesAccept=".kml"
                            treeInitialValue={this.props.idForImportDialog}
                            isLoading={this.state.importDialogLoading}
                        />
                    }
                </FMContainer>
            </SplitPane>
        );
    }

}

const mapStateToProps = (state: RootState): StateProps => ({
    idForImportDialog:
        getGroupIdNearestToSelectedNode(state, TreeType.geofencesTree, TreeDisplayStateType.mainGeofencesTree),
    editModeEnabled: getIsEditModeEnabled(state, TreeDisplayStateType.mainGeofencesTree),
});

export default connect(mapStateToProps)(withStyles(style)(GeofencesTree));
